import { combineReducers } from 'redux';
import { invitationActionTypes } from './Invitation.actionTypes';

const acceptInvitationDetailsInitialState = {
  pending: false,
  success: false,
  failure: false,
  successPayload: {},
  failurePayload: {},
};

const acceptInvitationDetailsReducer = (
  state = acceptInvitationDetailsInitialState,
  action
) => {
  switch (action.type) {
    case invitationActionTypes.ACCEPT_INVITATION_PENDING:
      return {
        ...state,
        pending: true,
        success: false,
        failure: false,
        successPayload: {},
        failurePayload: {},
      };
    case invitationActionTypes.ACCEPT_INVITATION_SUCCESS:
      return {
        ...state,
        pending: false,
        success: true,
        failure: false,
        successPayload: action.payload,
        failurePayload: {},
      };
    case invitationActionTypes.ACCEPT_INVITATION_FAILED:
      return {
        ...state,
        pending: false,
        success: false,
        failure: true,
        successPayload: {},
        failurePayload: action.payload,
      };
    case invitationActionTypes.ACCEPT_INVITATION_CLEANUP:
      return {
        ...state,
        pending: false,
        success: false,
        failure: false,
        successPayload: {},
        failurePayload: {},
      };
    default:
      return {
        ...state,
      };
  }
};
const getInvitationDetailsInitialState = {
  pending: false,
  success: false,
  failure: false,
  successPayload: {},
  failurePayload: {},
};

const getInvitationDetailsReducer = (
  state = getInvitationDetailsInitialState,
  action
) => {
  switch (action.type) {
    case invitationActionTypes.GET_INVITATION_DETAILS_PENDING:
      return {
        ...state,
        pending: true,
        success: false,
        failure: false,
        successPayload: {},
        failurePayload: {},
      };
    case invitationActionTypes.GET_INVITATION_DETAILS_SUCCESS:
      return {
        ...state,
        pending: false,
        success: true,
        failure: false,
        successPayload: action.payload,
        failurePayload: {},
      };
    case invitationActionTypes.GET_INVITATION_DETAILS_FAILED:
      return {
        ...state,
        pending: false,
        success: false,
        failure: true,
        successPayload: {},
        failurePayload: action.payload,
      };
    case invitationActionTypes.GET_INVITATION_DETAILS_CLEANUP:
      return {
        ...state,
        pending: false,
        success: false,
        failure: false,
        successPayload: {},
        failurePayload: {},
      };
    default:
      return {
        ...state,
      };
  }
};
const invitationDataReducer = (state = {}, action) => {
  switch (action.type) {
    case invitationActionTypes.SET_INVITATION_DATA:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

const invitationReducer = combineReducers({
  acceptInvite: acceptInvitationDetailsReducer,
  details: getInvitationDetailsReducer,
  invitationData: invitationDataReducer,
});
export default invitationReducer;
